@if (
  {
    webMeetingAgentEnabled: webMeetingAgentEnabled$ | async,
    currentUserId: currentUserId$ | async,
    currentMeeting: currentMeeting$ | async,
    currentMeetingScheduleId: currentMeetingScheduleId$ | async,
    visible: visible$ | async,
    showAddButton: showAddButton$ | async,
  } | ngrxPush;
  as data
) {
  @if (data.webMeetingAgentEnabled && data.currentUserId === data.currentMeeting?.presenterUserId) {
    @if (data.showAddButton) {
      <button class="notetaker-control-add-button" mat-button (click)="addMeetingBot()">
        <terra-icon icon="sparkle" variant="fill" size="20" aria-hidden="true" />
        Record and transcribe
        <ninety-chip color="brand" size="small">Beta</ninety-chip>
      </button>
    } @else if (data.visible) {
      <div class="notetaker-control">
        <terra-icon class="notetaker-control-icon" icon="sparkle" variant="fill" size="20" aria-hidden="true" />
        <span class="notetaker-control-label">{{ label(data.currentMeeting?.meetingBot?.status) }}</span>
        @if (
          data.currentMeeting?.meetingBot?.status === MeetingBotStatus.recording ||
          data.currentMeeting?.meetingBot?.status === MeetingBotStatus.paused
        ) {
          <terra-switch
            class="notetaker-control-switch"
            aria-label="Toggle Maz recording"
            [ngModel]="data.currentMeeting?.meetingBot?.status === MeetingBotStatus.recording"
            (ngModelChange)="toggleRecording($event)" />
        }
        <button
          class="notetaker-control-menu-trigger"
          mat-icon-button
          [disabled]="!data.currentMeeting?.meetingBot?.botId"
          [matMenuTriggerFor]="notetakerControlMenu"
          aria-label="Maz options">
          <terra-icon icon="more" size="20" />
        </button>
        <mat-menu #notetakerControlMenu="matMenu">
          @if (
            data.currentMeetingScheduleId &&
            (data.currentMeeting?.meetingBot?.status === MeetingBotStatus.active ||
              data.currentMeeting?.meetingBot?.status === MeetingBotStatus.creating)
          ) {
            <button mat-menu-item class="join-meeting-bot-now-button" (click)="joinBotNow()">Join now</button>
          }
          <button mat-menu-item class="remove-meeting-bot-button" (click)="removeMeetingBot()">
            Remove Maz from meeting
          </button>
        </mat-menu>
      </div>
    }
  }
}
